import { render, staticRenderFns } from "./BirimBazliRapor.vue?vue&type=template&id=088fd465"
import script from "./BirimBazliRapor.vue?vue&type=script&lang=js"
export * from "./BirimBazliRapor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports